import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';
import { shortMonthToFull, handleUserLevelAccessPermissions, getAllYears, validateRoles, validateMonthYears } from '../../../../Custom/Custom'
import { ToastContainer, toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import titlesData from '../../../../titles.json';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { generateReviewReport } from '../ExportPriceWagesExcel';
import { format } from 'date-fns';
import messages from '../.././../../assets/Messages.json';
import priceTitle from '../../../../price.json';
import { changeDateFormat } from "../../../../Custom/Custom";

const ReviewReport = () => {
  const [isDivision, setIsDivision] = useState(false);
  const [years, setYears] = useState([]);
  const [months, setMonth] = useState([]);
  const [yearName, setYearName] = useState(new Date().getFullYear()); // Set current year as default
  const [reportType, setReportType] = useState('');
  const [startDate, setStartDate] = useState();
  const [monthName, setMonthName] = useState('');
  const [buttonAccess, setButtonAccess] = useState({ userLevel: '', roles: '', isVisible: false });

  const token = useContext(MyContextProvider).token;
  // const decode_token = jwtDecode(token)
  const decode_token = getUserClaimsForUi();
  const navigate = useNavigate();
  // const config = {
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //   },
  // };
  const config = getAuthHeaders();
  const [dateSelectedError, setDateSelectedError] = useState(false);


  const getMonthsList = (e) => {
    showLoading(true)
    axios
      .get(`${API_URL}api/graph/getMonths/2019`, config)
      .then((res) => {
        let monthDataResponse = res.data;
        if (monthDataResponse.status) {
          setMonth(monthDataResponse.data);
          showLoading(false)
        }
      })
      .catch((err) => {
        console.error(err);
        showLoading(false);
      });
  }

  useEffect(() => {

    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level)

    const getYearList = () => {
      const startYear = 2014; // Starting year
      const endYear = new Date().getFullYear(); // Ending year

      const yearsArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearsArray.push(year);
      }

      setYears(yearsArray);
    };



    const userRole = async () => {
      showLoading(true)
      try {
        const role = await validateRoles(decode_token)
        if (role) {
          getYearList();
          getMonthsList();
        } else {

          alert("You are not an authorized user to capture the data for Pricing");
          navigate("/dashboard");
        }
        showLoading(false)
      } catch (error) {
        console.log(error);
        showLoading(false)
      }
    }

    userRole();

  }, []);

  const handleGenerateExcel = () => {
    if (!startDate) {
      setDateSelectedError(true);
      toast.error("Please select a date to generate the report.", messages.COLOR_RED);
      return;
    }
    
    if (!reportType) {
      toast.error("Please select a report type.", messages.COLOR_RED);
      return;
    }
  
    // Format the selected date correctly
    const formattedDate = startDate ? format(new Date(startDate), 'dd MMM yyyy') : '';
    const postData = {
      date_picker_week: formattedDate,
      reportType: reportType, // Use the selected report type
    };
  
    let sixtySevenvariationReport = '';
  
    showLoading(true);
  
    // Calculate the previous date based on the report type
    let previousDate;
    const dateForCalculation = new Date(startDate); // Clone the date for manipulation
  
    if (reportType === 'weekly') {
      previousDate = format(new Date(dateForCalculation.setDate(dateForCalculation.getDate() - 7)), 'dd MMM yyyy'); // One week prior
    } else if (reportType === 'monthly') {
      previousDate = format(new Date(dateForCalculation.setMonth(dateForCalculation.getMonth() - 1)), 'dd MMM yyyy'); // One month prior
    } else if (reportType === 'quarterly') {
      previousDate = format(new Date(dateForCalculation.setMonth(dateForCalculation.getMonth() - 3)), 'dd MMM yyyy'); // Three months prior
    } else if (reportType === 'yearly') {
      previousDate = format(new Date(dateForCalculation.setFullYear(dateForCalculation.getFullYear() - 1)), 'dd MMM yyyy'); // One year prior
    }
  
    // POST request to API
    axios
      .post(`${API_URL}api/price/prireviewreport`, postData, config)
      .then((response) => {
        sixtySevenvariationReport = response.data.data.GroupCodes;
  
        let excelFileName = `Pri67_Review_Report_${formattedDate}`;
  
        const excelObjectData = {
          fileName: excelFileName,
          reportType: excelFileName,
          fileType: 'xls',
          sheetName: "pri_67_review_report",
          firstRowMergeCells: "A1:C1",
          firstRowExportDate: changeDateFormat(new Date()),
          firstRowCellNumber: 12,
          priceDate: formattedDate,
          secondRowMergeCells: "A2:C2",
          secondRowText: `Review Report of 67 Necessary Items (Base Year 2011-12=100)`,
          thirdRowMergeCells: "A3:C3",
          // Update thirdRowText to use previousDate
          thirdRowText: `साप्ताहिक  प्रतिशत वृद्धि के आधार पर वस्तुओ का वर्गीकृत(आधार वर्ष 2011-12=100)\n(${previousDate})`,
          headerHindiColumns: [
            'वृद्धि दर प्रतिशत सीमा ', 'वस्तुओ की संख्या', 'वस्तु का नाम # असमानता %'
          ],
        };
  
        const transformedData = sixtySevenvariationReport.map((item, index) => [
          item.drange.trim(),
          item.itemCount,
          item.ITEM_NAME
        ]);
  
        excelObjectData.excelRowData = transformedData;
        generateReviewReport(excelObjectData);
      })
      .catch((error) => {
        console.error('API Error', error);
      })
      .finally(() => {
        showLoading(false);
      });
  };
  


  const storedLanguage = localStorage.getItem('language');

  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();
  const today = new Date();

  return (
    <>
      <GlobalLoading />
      <ToastContainer />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">

                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.REVIEW_REPORT : priceTitle.en.REVIEW_REPORT }} />

              </h4>

              <div className="row align-items-center">
                {isDivision &&
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION} </label>
                    <input typr="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                  </div>
                }

                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6 mb-3">
                  <label className="fw-bold h6">Select Week Date</label>
                  <DatePicker
                    className="form-control calendar_icon"
                    dateFormat="dd MMM yyyy"
                    placeholderText="DD MMM YYYY"
                    selected={startDate}
                    maxDate={today}
                    onChange={(date) => {
                      setStartDate(date);
                      setDateSelectedError(false); // Clear error when date is selected
                    }}
                    renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                      <div style={{ margin: 10, display: "flex", justifyContent: "center" }}>
                        <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                          {"<"}
                        </button>
                        <select
                          onChange={(e) => {
                            setYearName(parseInt(e.target.value)); // Update yearName when changed
                            changeYear(parseInt(e.target.value));
                          }}
                          value={yearName} // Update value to yearName
                        >
                          <option value="" disabled>Select Year</option>
                          {years &&
                            years.map((ele, index) => (
                              <option key={index} value={ele}>
                                {ele}
                              </option>
                            ))}
                        </select>

                        <select
                          value={date.getMonth()} // Use date.getMonth() instead of monthName
                          onChange={(e) => {
                            setMonthName(e.target.value); // Update monthName when changed
                            changeMonth(e.target.value);
                          }}
                        >
                          <option value="" disabled>Select Month</option>
                          {months &&
                            months
                              .filter((_, i) => !(currentYear === yearName && i > currentMonth))
                              .map((ele, i) => (
                                <option key={i} value={i}>
                                  {shortMonthToFull(ele.MONTH)}
                                </option>
                              ))}
                        </select>

                        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                          {">"}
                        </button>
                      </div>
                    )}
                  />

                </div>


                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6 mb-3">
                  <label className="fw-bold h6">Report Type</label>
                  <select
                    className="form-select"
                    value={reportType}
                    onChange={(e) => setReportType(e.target.value)}
                  >
                    <option value="" disabled>[-Select-]</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                    <option value="quarterly">Quarterly</option>
                    <option value="yearly">Yearly</option>
                  </select>
                </div>


                <div className="col-xl-2 col-lg-12 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button onClick={handleGenerateExcel} className="btn btn_orange">Search</button>                                </div>


              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}

export default ReviewReport